import React, { useEffect } from "react";
import {Typography} from "@mui/material";
import { getText } from "../../libs/utils";

const RegisterApprove = () => {
  return (
    <Typography variant="caption" align="center" style={{ maxWidth: 290, margin: "0 auto 7px", display: "inline-block" }}>
      {getText('headRegisterDoneText')}
    </Typography>
  );
};

export default RegisterApprove;
